import {
    useMutation,
} from '@tanstack/react-query'

import {
    useEffect,
} from 'react'

import {
    useLocation,
} from 'react-router-dom'
import FullScreenDialog from '../../Components/FullScreenDialog'
import acceptHrInvitationMutation from './services/accept-hr-invitation'

const AcceptHrInvitation = (ref) => {
    const location = useLocation()

    const queryParams = new URLSearchParams(location.search)
    const key = queryParams.get('key')

    const {
        error: mutationError,
        isPending: mutationIsPending,
        mutate,
        data: mutationData,
    } = useMutation({
        mutationFn: acceptHrInvitationMutation,
    })

    useEffect(() => {
        mutate({
            key,
        })
    }, [],
    )

    const companyName = mutationData?.companyName || 'Our Company'

    return (
        <div className="min-h-screen bg-white flex flex-col items-center justify-start pt-10 px-4">
            {/* Header */}
            <header className="text-xl font-bold text-center mb-8">
                Accept HR Invitation
            </header>

            {/* Dialog */}
            <div className="bg-green-100 p-6 rounded-2xl shadow-lg w-full max-w-md">
                <div className="bg-white p-6 rounded-xl shadow-inner text-center">
                    <h1 className="text-2xl font-extrabold text-gray-900 mb-4">
                        Welcome to {companyName}
                    </h1>

                    {/* Show error message */}
                    {mutationError && (
                        <p className="text-red-600 font-medium text-sm mb-6">
                            Something went wrong. Please check your invitation link.
                        </p>
                    )}

                    {/* Show loading */}
                    {mutationIsPending && (
                        <p className="text-blue-600 font-medium mb-4">
                            Processing your invitation...
                        </p>
                    )}

                    {/* Show success message */}
                    {mutationData && (
                        <div className="text-gray-700 text-base mb-6 space-y-2">
                            <p>You’ve successfully joined the team at <span className="font-semibold">{companyName}</span>!</p>
                            <p>Your account is now active and you have full access to our platform.</p>
                            <p>We’re thrilled to have you on board and can’t wait to see the impact you’ll make.</p>
                            <p>Feel free to explore the tools and resources available to you.</p>
                            <p>Let’s build something incredible — together.</p>
                        </div>
                    )}

                    <p className="text-sm text-gray-600 mt-4">
                        We’ve sent your temporary login credentials to your email. You may now close this window and check your inbox.
                    </p>

                </div>
            </div>
        </div>
    )
}

export default AcceptHrInvitation

